






















helpers = require('../../helpers.coffee')

module.exports =
  components:
    list: require('./list')

  props: ['taggable','prop_id']

  data: ->
    selected_tags: []
    list_item_options:
      checkbox: true
      can_edit: false

  computed:
    list_options: ->
      return unless @taggable
      tag_ids = for tag in @taggable.tags
        tag.id
      { filters: { id_not_in: tag_ids } }

  methods:
    pick: ->
      @$emit('picked', @selected_tags)

    selection_changed: (tags) ->
      @selected_tags = tags

    reloadTags: (tags) ->
      @$refs.tag_list.loadTags()




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/tags/picker_modal.vue